export default {
  computed : {
    values : function(){
      return Object.values(this.data)
    },

    average : function(){
      return parseFloat((this.values.reduce((a,b) => a + b, 0) / this.values.length).toFixed(2));
    },

    median : function(){
      const mid = Math.floor(this.values.length / 2);
      const sorted = [...this.values].sort((a, b) => a - b);
      return parseFloat((this.values.length % 2 !== 0 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2).toFixed(2));
    },

    variance : function(){
      return parseFloat((this.values.reduce((a, b) => a + Math.pow(b-this.average, 2), 0) / this.values.length).toFixed(2));
    },

    std_dev : function(){
      return parseFloat((Math.sqrt(this.variance)).toFixed(2));
    },

    ///

    average_values : function(){
      return new Array(this.values.length).fill(this.average);
    },

    median_values : function(){
      return new Array(this.values.length).fill(this.median);
    },

    ///

    average_series : function(){
      return {
        name : 'average',
        data : this.average_values
      }
    },

    median_series : function(){
      return {
        name : 'median',
        data : this.median_values
      }
    }
  },

  methods : {
    stat_enabled : function(stat){
      return this.stats.includes(stat)
    },

    toggle_stat : function(stat){
      if(this.stat_enabled(stat))
        this.stats.splice(this.stats.indexOf(stat), 1)
      else
        this.stats.push(stat)
    }
  }
}
